export const TRANSACTIONS = "/transactions";
export const ACCOUNTS = "/accounts";
